/* eslint-disable @trello/export-matches-filename */
import { forTemplate, localizeCount } from '@trello/i18n';
import { BoardIcon, GlyphProps } from '@trello/nachos/icons/board';
import { PowerUpIcon } from '@trello/nachos/icons/power-up';
import { ButlerBotIcon } from '@trello/nachos/icons/butler-bot';
import { HeartIcon } from '@trello/nachos/icons/heart';
import { TableIcon } from '@trello/nachos/icons/table';
import { ChecklistIcon } from '@trello/nachos/icons/checklist';
import { AdminChevronIcon } from '@trello/nachos/icons/admin-chevron';
import { SearchIcon } from '@trello/nachos/icons/search';
import { AttachmentIcon } from '@trello/nachos/icons/attachment';
import { CustomFieldIcon } from '@trello/nachos/icons/custom-field';
import { BoardCollectionIcon } from '@trello/nachos/icons/board-collection';
import { DownloadIcon } from '@trello/nachos/icons/download';
import { ViewTimelineIcon } from '@trello/nachos/icons/view-timeline';
import { ViewDashboardIcon } from '@trello/nachos/icons/view-dashboard';

const formatTemplate = forTemplate('mini_plan_comparison');

export interface FeatureListItem {
  content: string;
  tooltip: string | null;
  icon: React.FC<GlyphProps>;
}

export const premiumFeatureList: FeatureListItem[] = [
  {
    icon: ButlerBotIcon,
    // eslint-disable-next-line @trello/no-module-logic
    content: formatTemplate(['premium', 'features', 'automations']),
    // eslint-disable-next-line @trello/no-module-logic
    tooltip: formatTemplate(['premium', 'features', 'automations-tt-1']),
  },
  {
    icon: BoardCollectionIcon,
    // eslint-disable-next-line @trello/no-module-logic
    content: formatTemplate(['premium', 'features', 'collections']),
    // eslint-disable-next-line @trello/no-module-logic
    tooltip: formatTemplate(['premium', 'features', 'collections-tt']),
  },
  {
    icon: AdminChevronIcon,
    // eslint-disable-next-line @trello/no-module-logic
    content: formatTemplate(['premium', 'features', 'admin-security']),
    // eslint-disable-next-line @trello/no-module-logic
    tooltip: formatTemplate(['premium', 'features', 'admin-security-tt']),
  },
  {
    icon: DownloadIcon,
    // eslint-disable-next-line @trello/no-module-logic
    content: formatTemplate(['premium', 'features', 'csv-export']),
    // eslint-disable-next-line @trello/no-module-logic
    tooltip: formatTemplate(['premium', 'features', 'csv-export-tt']),
  },
  {
    icon: TableIcon,
    // eslint-disable-next-line @trello/no-module-logic
    content: formatTemplate(['premium', 'features', 'table-view']),
    // eslint-disable-next-line @trello/no-module-logic
    tooltip: formatTemplate(['premium', 'features', 'table-view-tt']),
  },
  {
    icon: ViewTimelineIcon,
    // eslint-disable-next-line @trello/no-module-logic
    content: formatTemplate(['premium', 'features', 'timeline-view']),
    // eslint-disable-next-line @trello/no-module-logic
    tooltip: formatTemplate(['premium', 'features', 'timeline-view-tt']),
  },
  {
    icon: ViewDashboardIcon,
    // eslint-disable-next-line @trello/no-module-logic
    content: formatTemplate(['premium', 'features', 'dashboard-view']),
    // eslint-disable-next-line @trello/no-module-logic
    tooltip: formatTemplate(['premium', 'features', 'dashboard-view-tt']),
  },
  {
    icon: HeartIcon,
    // eslint-disable-next-line @trello/no-module-logic
    content: formatTemplate(['premium', 'features', 'support']),
    // eslint-disable-next-line @trello/no-module-logic
    tooltip: formatTemplate(['premium', 'features', 'support-tt']),
  },
];

export const freeFeatureList: FeatureListItem[] = [
  {
    icon: BoardIcon,
    content: localizeCount('up to boards', 10),
    tooltip: null,
  },
  {
    icon: PowerUpIcon,
    // eslint-disable-next-line @trello/no-module-logic
    content: formatTemplate(['free', 'features', 'pups']),
    tooltip: null,
  },
  {
    icon: ButlerBotIcon,
    // eslint-disable-next-line @trello/no-module-logic
    content: formatTemplate(['free', 'features', 'automations']),
    // eslint-disable-next-line @trello/no-module-logic
    tooltip: formatTemplate(['free', 'features', 'automations-tt-1']),
  },
];

export const standardFeatureList: FeatureListItem[] = [
  {
    icon: BoardIcon,
    // eslint-disable-next-line @trello/no-module-logic
    content: formatTemplate(['standard', 'features', 'boards']),
    tooltip: null,
  },
  {
    icon: ChecklistIcon,
    // eslint-disable-next-line @trello/no-module-logic
    content: formatTemplate(['standard', 'features', 'checklists']),
    // eslint-disable-next-line @trello/no-module-logic
    tooltip: formatTemplate(['standard', 'features', 'checklists-tt']),
  },
  {
    icon: ButlerBotIcon,
    // eslint-disable-next-line @trello/no-module-logic
    content: formatTemplate(['standard', 'features', 'automations']),
    // eslint-disable-next-line @trello/no-module-logic
    tooltip: formatTemplate(['standard', 'features', 'automations-tt-1']),
  },
  {
    icon: AttachmentIcon,
    content: localizeCount('file attachments', 250),
    tooltip: null,
  },
  {
    icon: SearchIcon,
    // eslint-disable-next-line @trello/no-module-logic
    content: formatTemplate(['standard', 'features', 'searches']),
    // eslint-disable-next-line @trello/no-module-logic
    tooltip: formatTemplate(['standard', 'features', 'searches-tt']),
  },
  {
    icon: CustomFieldIcon,
    // eslint-disable-next-line @trello/no-module-logic
    content: formatTemplate(['standard', 'features', 'fields']),
    // eslint-disable-next-line @trello/no-module-logic
    tooltip: formatTemplate(['standard', 'features', 'fields-tt']),
  },
];
